import { render, staticRenderFns } from "./ShortcutDateSelector.vue?vue&type=template&id=88df7ee0&"
import script from "./ShortcutDateSelector.vue?vue&type=script&lang=js&"
export * from "./ShortcutDateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports